import { InfoIcon } from "lucide-react";
import H1 from "src/components/typography/h1";
import H4 from "src/components/typography/h4";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/ui/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "src/components/ui/table";
import { UserAvatar } from "src/views/header";

const data = [
  { level: 0, approvedProjects: "0", payoutTerms: "Same as old payout terms" },
  { level: 1, approvedProjects: "1", payoutTerms: "Same as old payout terms" },
  {
    level: 2,
    approvedProjects: "2",
    payoutTerms: "Within a week of project approval",
  },
];

export function LevelsInfoDialog(props: any) {
  return (
    <Dialog>
      <DialogTrigger>
        <div className="relative">
          {" "}
          <UserAvatar className="text-[18px] font-light " userTag={"L1"} />
          <InfoIcon className="absolute top-0 -right-2" size={"12px"} />
        </div>
      </DialogTrigger>

      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex gap-3">
            <H4>Levels</H4> <InfoIcon />
          </DialogTitle>
          <DialogDescription>
            The levels indicate the number of working days it may take for
            payouts and incentives to be processed.
          </DialogDescription>
        </DialogHeader>
        <Table className="min-w-full table-auto border-collapse">
          <TableHeader>
            <TableRow className="bg-gray-300  hover:bg-gray-300">
              <TableHead className="px-6 py-3 text-left text-sm font-semibold text-gray-900 border-b">
                Level
              </TableHead>
              <TableHead className="px-6 py-3 text-left text-sm font-semibold text-gray-900 border-b">
                Number of Apporved Projects
              </TableHead>
              <TableHead className="px-6 py-3 text-left text-sm font-semibold text-gray-900 border-b">
                Payout terms
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index} className="hover:bg-gray-100">
                <TableCell className="px-6 py-4 text-sm text-gray-800">
                  {row.level}
                </TableCell>
                <TableCell className="px-6 py-4 text-sm text-gray-800">
                  {row.approvedProjects}
                </TableCell>
                <TableCell className="px-6 py-4 text-sm text-gray-800">
                  {row.payoutTerms}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <DialogFooter>
          <DialogClose>close</DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
